import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'
import { getParentView } from 'Simple/Flow'
import useEnsureDefaultTab from './useEnsureDefaultTab'
import useEnsureTab from 'Logic/use-ensure-tab'
import { useDataValueOnce } from 'Logic/FlowShortcuts'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let tabs = useDataValue({
    context: 'global',
    path: 'tabs',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  let syncEventId = useDataValueOnce({
    context: 'tab',
    path: 'sync.event_id',
    viewPath: props.viewPath,
  })
  let [, tab_id] = getParentView(props.viewPath)
  let ensureDefaultTab = useEnsureDefaultTab(props, data)

  let tab = useMemo(
    () =>
      ensureDefaultTab(
        tabs.find(item => item.id === tab_id),
        tab_id,
        syncEventId
      ),
    [tab_id, location_id] // eslint-disable-line
  ) // only care about first render

  useEnsureTab({
    viewPath: props.viewPath,
    tab,
  })

  return tab
}
